module.exports = __webpack_public_path__ + "img/1f437.24f47e6.svg";